import MotorcycleIcon from '@material-ui/icons/Motorcycle'
import CarList from './CarList'

export default {
  name:'cars',
  options :{ label: 'Cars' },
  list: CarList,
  icon: MotorcycleIcon
}